export const locale = {
    lang: 'pl',
    data: {
        'Module permissions': 'Moduł uprawnień',
        'ROLE_RECEPTIONIST': 'Recepcjonista',
        'ROLE_WORKER': 'Pracownik',
        'ROLE_JUNIOR_MANAGER': 'Młodszy manager',
        'ROLE_MANAGER': 'Manager',
        'ROLE_ADMIN': 'Administrator',
        'Disallow': 'Zabroń',
        'Allow': 'Pozwól',
        'CREATE': 'DODAWANIE',
        'READ': 'ODCZYT',
        'UPDATE': 'AKTUALIZACJA',
        'DELETE': 'USUWANIE',
        'Calendar': 'Kalendarz',
        'Customers': 'Klienci',
        'Passes': 'Karnety',
        'Products': 'Produkty',
        'Point of sale': 'Sprzedaż',
        'Used products': 'Użyte produkty',
        'ASN': 'Awizacje',
        'Reports': 'Raporty',
        'Communication': 'Komunikacja',
        'Services': 'Usługi',
        'Workers': 'Pracownicy',
        'Employee schedule': 'Harmonogram pracowników',
        'Resources': 'Zasoby',
        'Customer sources': 'Źródła klientów',
        'VAT rates': 'Stawki podatku VAT',
        'Voucher templates': "Szablony karnetów",
        'Marketing vouchers': 'Vouchery marketingowe',
        'Public API access': 'Dostęp do publicznego API',
        'Message templates': 'Szablony wiadomości',
        'Marketing actions': 'Akcje marketingowe',
        'Settings': 'Ustawienia',
        'Notification accounts': 'Konta powiadomień',
        'Orders': 'Zamówienia',
        'Categories': 'Kategorie',
        'Manufacturers': 'Producenci',
        'Suppliers': 'Dostawcy',
        'Units': 'Jednostki',
        'Security': 'Bezpieczeństwo'
    }
};
